import { computed, ref } from 'vue'

export const cobrandData = ref({})
export const offerData = ref({})
export const customerData = ref({})
export const trackingParams = ref({})
export const presetFirstName = ref('')
export const presetMiddleName = ref('')
export const presetLastName = ref('')
export const presetEmail = ref('')
export const campaignDetails = ref(null)
export const creditCardData = ref(null)

export const signupMilestoneName = 'Signup Milestone Recorded'
export const signupMilestones = {
  SIGNUP_STARTED: 'SIGNUP_STARTED',
  LEAD_GENERATED: 'LEAD_GENERATED',
  SECURITY_INFO_RECEIVED: 'SECURITY_INFO_RECEIVED',
  IDMA_QUESTIONS_PRESENTED: 'IDMA_QUESTIONS_PRESENTED',
  IDMA_COMPLETED: 'IDMA_COMPLETED',
  PLAN_SELECTED: 'PLAN_SELECTED', // No plan selection step in the widget yet
  CREDIT_CARD_STARTED: 'CREDIT_CARD_STARTED',
  CREDIT_CARD_ATTEMPT: 'CREDIT_CARD_ATTEMPT',
  SIGNUP_COMPLETED: 'SIGNUP_COMPLETED',
}

export const externalLoginLink = computed(() => `${import.meta.env.VITE_FA_SERVER}/oauth2/authorize/?client_id=${import.meta.env.VITE_FA_CLIENT_ID}&redirect_uri=${import.meta.env.VITE_TLS_URL}/auth&response_type=code&scope=openid%20offline_access&state=signup`)
export const passwordlessLoginLink = computed(() => `${import.meta.env.VITE_FA_SERVER}/oauth2/passwordless/${customerData.value.passwordlessCode}/?client_id=${import.meta.env.VITE_FA_CLIENT_ID}&redirect_uri=${import.meta.env.VITE_TLS_URL}/auth&response_type=code&scope=openid offline_access`)

export const encodedTrackingParams = computed(() => new URLSearchParams(trackingParams.value).toString())

export const hasTrial = computed(() => {
  const plans = offerData.value?.memberPlans?.signupPlans || offerData.value?.memberPlans?.plans
  if (customerData.value?.planType)
    return plans.find(x => x.planType === customerData.value.planType).isTrial

  return false
})

/**
 * Returns true if the current PID has a sponsored plan
 */
export const hasSponsoredPlan = computed(() => {
  const plans = offerData.value?.memberPlans?.signupPlans || offerData.value?.memberPlans?.plans
  return plans
    ? plans.findIndex(x => x.planType === 'SPONSORED') > -1
    : false
})

export const isSponsoredPlan = computed(() => {
  return customerData.value?.isFinancialObligationMet && customerData.value.planType === 'SPONSORED'
})
